import { ActionReducerMap } from '@ngrx/store';
import { alarmeReducer, AlarmeState } from './AlarmeStore/alarme.store';
import {
  evenementSpontaneReducer,
  EvenementSpontaneState,
} from './EvenementSpontaneStore/evenement-spontane.store';
import {
  scenarioPreprogrammeReducer,
  ScenarioPreprogrammeState,
} from './ScenarioPreprogrammeStore/scenario-preprogramme.store';
import {
  EtapeScenarioState,
  etapesScenarioReducer,
} from './EtapeStore/etape.store';
import {
  planGestionMobiliteReducer,
  PlanGestionMobiliteState,
} from './PlanGestionMobiliteStore/plan-gestion-mobilite.store';
import {
  sousSystemeReducer,
  SousSystemeState,
} from './SousSystemeStore/sous-systeme.store';
import {
  equipementReducer,
  EquipmentState,
} from './EquipementStore/equipement.store';
import {
  associationSegmentReducer,
  AssociationSegmentState,
} from './AssociationSegmentStore/association-segment.store';
import {
  sessionReducer,
  SessionEditionState,
} from './SessionStore/session.store';
import {
  rapportSousSystemeReducer,
  RapportSousSystemeState,
} from './RapportSousSystemeStore/rapport-sous-systeme.store';
import { accountReducer, AccountState } from './AccountStore/account.store';
import {
  avancementReducer,
  AvancementState,
} from './AvancementStore/avancement.store';
import { logsReducer, LogsState } from './LogsStore/logs.store';

export interface MainStoreState {
  alarmes: AlarmeState;
  evenementSpontanes: EvenementSpontaneState;
  scenarioPreprogrammes: ScenarioPreprogrammeState;
  etapesScenario: EtapeScenarioState;
  planGestionMobilites: PlanGestionMobiliteState;
  sousSystemes: SousSystemeState;
  equipements: EquipmentState;
  associationSegments: AssociationSegmentState;
  sessions: SessionEditionState;
  account: AccountState;
  rapportSousSystemes: RapportSousSystemeState;
  avancements: AvancementState;
  logs: LogsState;
}

export const reducers: ActionReducerMap<MainStoreState> = {
  alarmes: alarmeReducer,
  evenementSpontanes: evenementSpontaneReducer,
  scenarioPreprogrammes: scenarioPreprogrammeReducer,
  etapesScenario: etapesScenarioReducer,
  planGestionMobilites: planGestionMobiliteReducer,
  sousSystemes: sousSystemeReducer,
  equipements: equipementReducer,
  associationSegments: associationSegmentReducer,
  sessions: sessionReducer,
  account: accountReducer,
  rapportSousSystemes: rapportSousSystemeReducer,
  avancements: avancementReducer,
  logs: logsReducer,
};
